import { createStore } from "vuex";
import Api from "@/modules/axios";
import config, { getCountry } from "@/config";

const FONCTION_PROF = 1300;

export default createStore({
  state: {
    isLogged: false,
    user: null,
    country: getCountry(),
    services: [],
    statutsServices: [],
    allServicesAreLoading: false,
  },
  getters: {
    isLogged(state) {
      return state.isLogged;
    },
    user(state) {
      return state.user;
    },
    isEleve(state) {
      return state.user.fonction.id <= FONCTION_PROF;
    },
    country(state) {
      return state.country;
    },
    services(state) {
      return state.services;
    },
    statutsServices(state) {
      return state.statutsServices;
    },
    allServicesAreLoading(state) {
      return state.allServicesAreLoading;
    },
    baseUrl(state) {
      return process.env[`VUE_APP_API_URL_${state.country.toUpperCase()}`];
    },
    permissions(state) {
      return state.permissions;
    },
    hasPerm: (state) => (perm) => state.user.permissions.includes(perm),
    hasPerms: (state) => (perms) => perms.every((perm) => state.user.permissions.includes(perm)),
  },
  mutations: {
    setLogged(state) {
      state.isLogged = true;
    },
    setUser(state, user) {
      state.user = user;
      if (user.avatar) {
        state.user.avatar = user.avatar;
      }
    },
    setCountry(state, country) {
      state.country = country;
    },
    setServices(state, services) {
      state.services = services;
    },
    setStatutsServices(state, statutsServices) {
      state.statutsServices = statutsServices;
    },
    setAllServicesAreLoading(state, allServicesAreLoading) {
      state.allServicesAreLoading = allServicesAreLoading;
    },
    setAvatar(state, { avatar, avatar_from_library: lib }) {
      state.user.avatar = avatar;
      state.user.avatar_from_library = lib;
    },
    setPermissions(state, permissions) {
      state.user.permissions = permissions;
    },
  },
  actions: {
    fetchServices(store) {
      return Api()
        .get("/service/")
        .then(({ data }) => {
          // Rediriger vers le service s'il n'y en a qu'un
          // 86caxcpx0: ne pas le faire pour permettre de se déconnecter (bcp de problème en DE mais pas FR)
          // if (data.length === 1 && window.location.pathname === "/" && store.getters.country !== "de") {
          //   window.location = data[0].url;
          // }
          store.commit("setServices", data);
        });
    },
    login(store, { noRedirect = false }) {
      store.commit("setAllServicesAreLoading", true);
      return Api({ noHeader: true })
        .get("/identify/")
        .then((res) => {
          store.commit("setLogged");
          store.commit("setUser", res.data.user);
          store.commit("setAllServicesAreLoading", false);
          store.dispatch("fetchServices");
        })
        .catch((err) => {
          if (err.response && err.response.status === 403 && !noRedirect) {
            window.location = config.loginUrl;
          }
        });
    },
  },
});
